<template>
  <div class="dial-track">
    <UserTrack :size="120" />
    <span class="message" v-html="$userEngine.getDialReckoner"></span>
  </div>
</template>

<script>
  import UserTrack from '@/components/v5/elements/UserTrack.vue';

  export default {
    components: {
      UserTrack
    },
  }
</script>

<style lang="scss" scoped>
  .dial-track {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 0.9rem;
  }
</style>